import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { DCUITheme } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { ColorPickerFormGroup } from "../../../../../common/color-picker-form-group/color-picker-form-group";
import { ThemingFormGroupWrapper } from "@containers/common/theming-input-form-group/theming-form-group-wrapper";
import { PageLevelTypes } from "@enums/page-level-types";

type DCUIThemingThemeHeaderSectionProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    dcuiTheme: DCUITheme;
    inheritedDCUITheme: DCUITheme;
    pageLevel: PageLevelTypes;
    updateDCUIThemePropertyValue: (dcuiTheme: DCUITheme) => void;
};

export const DCUIThemingThemeHeaderSection = (props: DCUIThemingThemeHeaderSectionProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        dcuiTheme,
        inheritedDCUITheme,
        pageLevel,
        updateDCUIThemePropertyValue
    } = props;

    const handleHeaderBackgroundColorChange = (newValue: string) => {
        const newPropertyValue: DCUITheme = {
            ...dcuiTheme,
            header: {
                ...dcuiTheme.header,
                backgroundColor: newValue
            }
        };
        updateDCUIThemePropertyValue(newPropertyValue);
    };

    const handleResetHeaderBackgroundColor = () => {
        const newPropertyValue: DCUITheme = {
            ...dcuiTheme,
            header: {
                ...dcuiTheme.header,
                backgroundColor: inheritedDCUITheme.header.backgroundColor
            }
        };
        updateDCUIThemePropertyValue(newPropertyValue);
    };

    return (
        <div>
            <ThemingFormGroupWrapper
                inheritedThemingPropertyValue={inheritedDCUITheme.header.backgroundColor}
                currentThemingPropertyValue={dcuiTheme.header.backgroundColor}
                pageLevel={pageLevel}
            >
                <ColorPickerFormGroup
                    controlId={"dcui-theming-header-background-color-picker"}
                    automationId={"dcui-theming-header-background-color-picker"}
                    label={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.theme.sections.header.inputs.backgroundColor.label}
                    ariaLabel={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.theme.sections.header.inputs.backgroundColor.label}
                    disabled={isDisabled}
                    isRequired={true}
                    layout={layout}
                    labelWidth={labelWidth}
                    value={dcuiTheme.header.backgroundColor || ""}
                    onChange={handleHeaderBackgroundColorChange}
                    position={"bottom"}
                    afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.theme.sections.header.inputs.backgroundColor.tooltip}
                    afterLabelIcon={isDisabled ? null : faUndo}
                    afterLabelIconOnClick={handleResetHeaderBackgroundColor}
                />
            </ThemingFormGroupWrapper>
        </div>
    );
};